<script setup lang="ts">
import SvgIcon from "@/components/ui/SvgIcon/SvgIcon.vue";

import DecorativeShadows from "./DecorativeShadows.vue";
</script>

<template>
  <div class="right-panel">
    <DecorativeShadows />

    <SvgIcon name="general/logo-named" class="logo" />
  </div>
</template>

<style lang="scss" scoped>
@use "@/styles/global/palette";

$gradient: linear-gradient(180deg, palette.$brand-100 0%, palette.$brand-110 100%);

.right-panel {
  width: 100%;
  height: 100%;
  background: $gradient;
  display: flex;
  flex-direction: column;
  padding: 80px 32px 20px;
  position: relative;
  overflow: hidden;
}

.logo {
  width: 109px;
  height: 20px;
  margin-top: auto;
  margin-bottom: 16px;
  align-self: center;
  color: palette.$brand-10;

  --logo-inner: #{palette.$brand-100};
}
</style>
